/**
 * @param {RootState} state
 * @return {AuthState}
 */
export const authSlice = (state) => state.auth;
